function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 304 304",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 556.995,
    cy: 524.952,
    r: 458.336,
    style: {
      fill: "#0f6680"
    },
    transform: "translate(-32.71 -22.087)scale(.33155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-16.446c-.3.879-.955.56-1.573.817-.509.262-.982.599-1.591.612-2.032 1.62-4.884 2.776-7.222 4.414l-.202.118q.192 1.281.192 2.573a17 17 0 0 1-.372 3.513 35 35 0 0 1 7.642 2.852A8.9 8.9 0 0 1 1.521 0c.767-2.301 1.474-4.622 2.017-6.917.643-.382.406-1.342.606-2.034.891-.221.498-1.681.936-2.331.303-.717 0-1.196-.364-1.724l-.967.259c-.027.12-.067.174-.117.174-.291 0-.924-1.809-1.276-3.075l-1.005-.408-.672.268z",
    style: {
      fill: "#d6ab6d",
      fillRule: "nonzero"
    },
    transform: "translate(215.036 81.484)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-9.994c-.177.133-.311.316-.463.332-.617.107-.698.872-1.042 1.303-.591 1.047-2.011.622-2.927 1.17l-.019.001c-.147 0-.288-.035-.427-.07a1.8 1.8 0 0 0-.423-.069.8.8 0 0 0-.346.079c-1.65.224-3.053.566-4.697.849-.882.285-1.619.804-2.534.804q-.23 0-.479-.048l-.137.011.069.063a8.1 8.1 0 0 1 1.864 2.887A13.7 13.7 0 0 1-3.438 0c.137-.307.273-.613.388-.914.629-1.958 1.14-4.521 2.953-5.685l1.068.116c.404-.555.589-.998-.068-1.332l-.104-.2C.798-8.749.269-9.357 0-9.994",
    style: {
      fill: "#e9d0ad",
      fillRule: "nonzero"
    },
    transform: "translate(288.853 124.95)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-30.889a15.48 15.48 0 0 0-10.978 4.547c-6.063 6.063-6.063 15.893 0 21.956A15.46 15.46 0 0 0-2.236 0q-.038-.48-.037-.962a12.1 12.1 0 0 1 3.555-8.571 12.1 12.1 0 0 1 3.944-2.637 5.14 5.14 0 0 1 6.344-7.458 14 14 0 0 1 2.63-2.022 15.5 15.5 0 0 0-3.222-4.692A15.47 15.47 0 0 0 0-30.889",
    style: {
      fill: "#e9d0ad",
      fillRule: "nonzero"
    },
    transform: "translate(112.021 121.63)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-20.454a8.8 8.8 0 0 1-2.011 3.108 8.77 8.77 0 0 1-6.225 2.579 9 9 0 0 1-1.945-.216 11.66 11.66 0 0 0-1.445 8.888 7.87 7.87 0 0 1 6.574 2.241l.068.07a7.26 7.26 0 0 1 4.155-1.3c1.864 0 3.727.712 5.15 2.134A7.3 7.3 0 0 1 5.889-.617q.72.275 1.416.617.32-.276.625-.581c4.548-4.547 4.548-11.919 0-16.467A11.6 11.6 0 0 0 0-20.454",
    style: {
      fill: "#d6ab6d",
      fillRule: "nonzero"
    },
    transform: "translate(138.871 189.747)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-16.17A8.086 8.086 0 1 0 .002 0 8.086 8.086 0 0 0 0-16.17",
    style: {
      fill: "#d6ab6d",
      fillRule: "nonzero"
    },
    transform: "translate(31.332 185.832)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-14.415a7.2 7.2 0 0 0-5.096 2.111 7.205 7.205 0 0 0 0 10.193A7.18 7.18 0 0 0 0 0a7.209 7.209 0 0 0 0-14.415",
    style: {
      fill: "#d6ab6d",
      fillRule: "nonzero"
    },
    transform: "translate(112.058 75.454)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-18.155a11.8 11.8 0 0 0-2.767 2.499 16.8 16.8 0 0 1-2.559 7.395 11.6 11.6 0 0 0 1.998 6.417A8.14 8.14 0 0 1 .646-2.881c1.566 0 3.148.453 4.54 1.399A8 8 0 0 1 6.83 0c.043-.322.089-.644.154-.962-.668-.66.061-1.462.391-2.214l.043.001c.249 0 .407-.153.556-.306.148-.152.286-.305.496-.305q.053 0 .114.014l.184-.496a30.8 30.8 0 0 1-5.725-13.63A11.4 11.4 0 0 1 0-18.155",
    style: {
      fill: "#d6ab6d",
      fillRule: "nonzero"
    },
    transform: "translate(165.696 234.632)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-18.455a13.17 13.17 0 0 1-7.839 2.575c-1.615 0-3.23-.294-4.758-.883-3.63 3.914-3.542 10.033.265 13.84A9.95 9.95 0 0 0-5.275 0a9.95 9.95 0 0 0 7.057-2.923c3.898-3.897 3.898-10.217 0-14.114A10 10 0 0 0 0-18.455",
    style: {
      fill: "#e9d0ad",
      fillRule: "nonzero"
    },
    transform: "translate(80.122 183.405)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-3.892-.186.082A18.3 18.3 0 0 1 1.478 0q.18-.743.441-1.466A8.2 8.2 0 0 1 0-3.892",
    style: {
      fill: "#d6ab6d",
      fillRule: "nonzero"
    },
    transform: "translate(252.352 135.766)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-17.743c-2.27 0-4.541.866-6.273 2.599a9 9 0 0 0-1.469 1.935 13.26 13.26 0 0 1 .402 9.323q.463.682 1.067 1.288A8.84 8.84 0 0 0 0 0a8.872 8.872 0 0 0 6.273-15.144A8.84 8.84 0 0 0 0-17.743",
    style: {
      fill: "#d6ab6d",
      fillRule: "nonzero"
    },
    transform: "translate(96.776 154.285)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-25.5a6 6 0 0 1-1.156 1.626 5.94 5.94 0 0 1-4.211 1.745 5.94 5.94 0 0 1-3.319-1.009c-.61.431-1.192.918-1.737 1.465-5.16 5.16-5.16 13.526 0 18.685A13.1 13.1 0 0 0-5.837 0q.129-.138.264-.274a9.95 9.95 0 0 1 7.057-2.923c1.833 0 3.666.502 5.275 1.505q.789-.582 1.504-1.296a13.16 13.16 0 0 0 3.212-5.214 8.85 8.85 0 0 1-1.532-4.997 8.9 8.9 0 0 1 1.13-4.326 13.2 13.2 0 0 0-2.81-4.148A13.16 13.16 0 0 0 0-25.5",
    style: {
      fill: "#cde1ea",
      fillRule: "nonzero"
    },
    transform: "translate(70.785 160.248)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.08A9.95 9.95 0 0 0-7.322-.882C-5.794-.294-4.179 0-2.564 0 .194 0 2.952-.858 5.275-2.575A9.97 9.97 0 0 0 0-4.08",
    style: {
      fill: "#c3b7a2",
      fillRule: "nonzero"
    },
    transform: "translate(72.835 161.467)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.269-9.317a8.88 8.88 0 0 1 0 9.331 13.27 13.27 0 0 1 0-9.331",
    style: {
      fill: "#b6986c",
      fillRule: "nonzero"
    },
    transform: "matrix(-1.38019 .05951 .05951 1.38019 86.265 148.913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-45.925a21.1 21.1 0 0 1-8.057 3.031 14 14 0 0 1-2.058 2.625 13.7 13.7 0 0 1-8.437 3.968c.527 1.336.791 2.751.791 4.167a11.3 11.3 0 0 1-3.319 8.009 11.4 11.4 0 0 1-1.755 1.438 11.6 11.6 0 0 1 5.826 3.16 11.58 11.58 0 0 1 3.402 8.204 11.7 11.7 0 0 1-.553 3.576c1.876.401 3.729 1.166 5.647 1.166l.15-.001.176.388c.261-.127.402-.194.519-.194.143 0 .25.1.496.315.773.377 1.693.105 2.558.306.134.209.197.31.319.31.112 0 .273-.085.58-.246.124.414.323.529.553.529.142 0 .296-.044.451-.087a1.8 1.8 0 0 1 .459-.087.54.54 0 0 1 .277.069l-.078.262c.251.1.523.127.802.127.165 0 .332-.009.498-.019a8 8 0 0 1 .496-.019c.359 0 .7.047.988.247.47.648 1.175.463 1.781.565h.031c.245 0 .438.123.63.247.192.123.381.247.619.247a1 1 0 0 0 .108-.009l.4-.546.172.778c.184.021.365.078.551.078a.7.7 0 0 0 .462-.165l-.683-.438c.347-.241.52-.361.829-.361.307 0 .749.119 1.63.355l-.47.422c.529 1.157 1.731.567 2.62 1.028a.12.12 0 0 0 .068.017c.118 0 .306-.103.485-.151l.641.463c.353-.076.524-.482.839-.482a.56.56 0 0 1 .314.117c-.141.498.188.673.626.673.505 0 1.158-.233 1.405-.473l1.139.573a1.7 1.7 0 0 0-.093-.858l1.559.608A.3.3 0 0 0 16.328-2a.55.55 0 0 0-.319.129v.703l.579-.239c.119.315.238.58.672.58h.005c.56.224 1.113.827 1.778.827.157 0 .32-.034.49-.113l.036-.409.1-.015.103.274q.506-.355.999-.731c-.603-.252-.938-.281-.767-1.138.128-1.462-.62-3.075-1.266-4.309l.109-.452c-1.003-.565-.659-1.904-.945-2.878l-.425-.296.596-.52-.079-.045a8.9 8.9 0 0 1-4.229 1.072 8.87 8.87 0 0 1-6.295-2.607 8.87 8.87 0 0 1-2.607-6.294c0-1.559.407-3.117 1.221-4.503a17.6 17.6 0 0 1-2.904-2.35 18 18 0 0 1-1.054-1.149A6.45 6.45 0 0 1 .31-22.899a6.45 6.45 0 0 1-4.578 1.896 6.45 6.45 0 0 1-4.577-1.896 6.46 6.46 0 0 1-1.896-4.578c0-1.657.632-3.314 1.896-4.578a6.46 6.46 0 0 1 4.577-1.896 6.5 6.5 0 0 1 2.863.666 17.7 17.7 0 0 1-.581-4.508A17.64 17.64 0 0 1 0-45.925",
    style: {
      fill: "#c0d9e3",
      fillRule: "nonzero"
    },
    transform: "translate(209.295 238.67)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-29.587a21.3 21.3 0 0 1-6.604 6.625 17.6 17.6 0 0 0-1.986 8.133 17.7 17.7 0 0 0 .58 4.507c.62.305 1.2.715 1.716 1.231a6.45 6.45 0 0 1 1.815 5.592q.497.591 1.055 1.149A17.8 17.8 0 0 0-.521 0 9 9 0 0 1 .866-1.791 8.87 8.87 0 0 1 7.16-4.399a8.87 8.87 0 0 1 6.294 2.608c.286.286.543.591.782.905.074-.252.1-.536.286-.672.307-.054.577-.071.611-.459a1 1 0 0 0 .095.006c.652 0 .558-.897 1.081-1.105.416-.084.68-.338.881-.654a6.1 6.1 0 0 1-2.047-1.349 6.08 6.08 0 0 1-1.788-4.312c0-1.561.596-3.122 1.788-4.313a6.1 6.1 0 0 1 1.682-1.193 10.23 10.23 0 0 1-1.851-4.865 4.97 4.97 0 0 1-3.444-1.461 4.98 4.98 0 0 1-1.462-3.518 4.97 4.97 0 0 1 .992-2.997A18.4 18.4 0 0 1 0-29.587",
    style: {
      fill: "#adc394",
      fillRule: "nonzero"
    },
    transform: "translate(218.419 206.947)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-11.441q-1.176.744-2.394 1.387a5.1 5.1 0 0 1-1.959.955 35 35 0 0 1-5.5 1.941v.058A13.75 13.75 0 0 1-11.824 0a21.1 21.1 0 0 0 8.057-3.031 17.8 17.8 0 0 1 6.271-6.8A18.6 18.6 0 0 1 0-11.441",
    style: {
      fill: "#b7a78f",
      fillRule: "nonzero"
    },
    transform: "translate(214.499 179.413)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.8A17.74 17.74 0 0 0-6.271 0a21.3 21.3 0 0 0 3.645-2.924A21.3 21.3 0 0 0 .333-6.626 15 15 0 0 1 0-6.8",
    style: {
      fill: "#a09b65",
      fillRule: "nonzero"
    },
    transform: "translate(217.958 175.227)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-15.533a11.3 11.3 0 0 1-5.682 1.866A30.8 30.8 0 0 0 .043-.037l.076-.204C.199-.063.29 0 .39 0c.122 0 .259-.095.406-.19s.305-.191.469-.191a.43.43 0 0 1 .245.079q.032.015.071.015c.171 0 .45-.203.738-.319l-.45-.297.325-.527.491.827.272-.402C4.326-.93 5.675-.763 7.03-.7c.201-.178.397-.248.591-.248.265 0 .526.132.79.297l.264.059c.37-1.162.555-2.37.553-3.577a11.58 11.58 0 0 0-3.402-8.204A11.6 11.6 0 0 0 0-15.533",
    style: {
      fill: "#ad936b",
      fillRule: "nonzero"
    },
    transform: "translate(177.749 228.787)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-11.167a6.1 6.1 0 0 0-1.683 1.192A6.08 6.08 0 0 0-3.47-5.662a6.08 6.08 0 0 0 1.787 4.313A6.1 6.1 0 0 0 .365 0C.86-.773.974-1.924 1.961-1.924l.079.003c.704-.598.951-1.501 1.914-1.703l.133-.725q.156.017.3.017c.184 0 .353-.023.498-.082a23.5 23.5 0 0 1-4.439-6.174A11 11 0 0 1 0-11.167",
    style: {
      fill: "#998b52",
      fillRule: "nonzero"
    },
    transform: "translate(241.662 201.739)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-14.049a7.8 7.8 0 0 0-2.549.781A8.86 8.86 0 0 1-5.13-7.657a9 9 0 0 1-1.738 1.355A7.85 7.85 0 0 0-4.562-.671q.365.364.762.671A16.9 16.9 0 0 1-.462-4.738a16.9 16.9 0 0 1 4.284-3.116l.002-.006a11 11 0 0 1-.734-.675A11.6 11.6 0 0 1 0-14.049",
    style: {
      fill: "#99c2d2",
      fillRule: "nonzero"
    },
    transform: "translate(122.809 200.735)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.254q-.504 0-1.006.065a11.6 11.6 0 0 0 3.09 5.514q.356.356.734.675a7.24 7.24 0 0 1 1.824-3.045q.47-.467.994-.833l-.068-.07A7.85 7.85 0 0 0 0-6.254",
    style: {
      fill: "#958767",
      fillRule: "nonzero"
    },
    transform: "translate(124.199 189.878)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-12.738q-.514-.001-1.038.085A6.37 6.37 0 0 0 1.022-.085 6.368 6.368 0 0 0 0-12.738",
    style: {
      fill: "#7fb2c7",
      fillRule: "nonzero"
    },
    transform: "translate(100.134 236.827)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-24.865A34.98 34.98 0 0 1-9.93-5.073q-.32.319-.644.629a21 21 0 0 1-.873 2.665 31 31 0 0 1 3.435.917 17.7 17.7 0 0 1 3.897-.434c2.259 0 4.52.432 6.645 1.296a23.46 23.46 0 0 1 6.034-10.315l.143-.142a8.3 8.3 0 0 1-4.412-2.306 8.3 8.3 0 0 1-2.436-5.874 8.3 8.3 0 0 1 1.563-4.861A12.4 12.4 0 0 1 0-24.865",
    style: {
      fill: "#b1d1dd",
      fillRule: "nonzero"
    },
    transform: "translate(236.601 163.898)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.696c-1.308 0-2.615.144-3.896.433A30.7 30.7 0 0 1 2.988 0a4.98 4.98 0 0 1 3.316-1.012q.15-.699.342-1.388A17.7 17.7 0 0 0 0-3.696",
    style: {
      fill: "#a6bc92",
      fillRule: "nonzero"
    },
    transform: "translate(230.916 167.214)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.665A35 35 0 0 1-2.727-.323 32 32 0 0 1-.873 0Q-.346-1.308 0-2.665",
    style: {
      fill: "#ada18c",
      fillRule: "nonzero"
    },
    transform: "translate(221.993 161.44)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-13.717a12.5 12.5 0 0 1-7.794.675A8.3 8.3 0 0 0-9.356-8.18a8.3 8.3 0 0 0 2.435 5.874A8.3 8.3 0 0 0-2.509 0a23.6 23.6 0 0 1 4.204-3.292 13.8 13.8 0 0 1-.031-6.615A18.3 18.3 0 0 0 0-13.717",
    style: {
      fill: "#a58f69",
      fillRule: "nonzero"
    },
    transform: "translate(252.096 149.452)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.768A21 21 0 0 1-1.358 0a17.5 17.5 0 0 1 4.794-1.851A31 31 0 0 0 0-2.768",
    style: {
      fill: "#86b4c7",
      fillRule: "nonzero"
    },
    transform: "translate(220.787 165.264)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.445a17.6 17.6 0 0 0-4.794 1.851q-.173.295-.356.586A18.4 18.4 0 0 0 5.91-.198a5 5 0 0 1 .974-.984A30.7 30.7 0 0 0 0-4.445",
    style: {
      fill: "#82a288",
      fillRule: "nonzero"
    },
    transform: "translate(225.533 168.847)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.503A35 35 0 0 1-2.698-1.61 18.6 18.6 0 0 0-.194 0q.34-.215.689-.411c.524-.895.977-1.821 1.359-2.768A31 31 0 0 0 0-3.503",
    style: {
      fill: "#8d8d81",
      fillRule: "nonzero"
    },
    transform: "translate(218.226 165.832)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.586q-.348.198-.689.412.166.089.333.174.183-.29.356-.586",
    style: {
      fill: "#7e8360",
      fillRule: "nonzero"
    },
    transform: "translate(218.911 166.073)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-17.392c-2.253 0-4.507.86-6.226 2.578-3.438 3.439-3.438 9.014 0 12.451A8.76 8.76 0 0 0-1.946 0 11.7 11.7 0 0 1-.301-2.065a11.6 11.6 0 0 1 8.537-3.406A8.807 8.807 0 0 0 0-17.392",
    style: {
      fill: "#7fb2c7",
      fillRule: "nonzero"
    },
    transform: "translate(127.493 169.049)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.691c-2.98 0-5.96 1.137-8.233 3.41A11.7 11.7 0 0 0-9.878-.217c.64.145 1.293.217 1.946.217 2.253 0 4.506-.86 6.225-2.579a8.8 8.8 0 0 0 2.01-3.108A10 10 0 0 0 0-5.691",
    style: {
      fill: "#847e65",
      fillRule: "nonzero"
    },
    transform: "translate(138.452 169.347)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-32.038q-.48.415-.992.769.14.704.141 1.42a7.26 7.26 0 0 1-2.133 5.159 7.26 7.26 0 0 1-5.15 2.134 7.25 7.25 0 0 1-4.723-1.74 7.85 7.85 0 0 1-5.068 1.847 7.85 7.85 0 0 1-4.806-1.635c-2.95 6.262-1.838 13.963 3.338 19.138A16.83 16.83 0 0 0-7.454 0c4.32 0 8.641-1.649 11.938-4.946a17 17 0 0 0 2.303-2.863v-.122a11.6 11.6 0 0 1 2.559-7.272c.116-1.17.111-2.348-.017-3.516a11.4 11.4 0 0 1-2.756-2.03 11.3 11.3 0 0 1-3.261-9.143A17 17 0 0 0 0-32.038",
    style: {
      fill: "#99c2d2",
      fillRule: "nonzero"
    },
    transform: "translate(148.962 234.007)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.386Q.282-.709.423 0q.513-.354.992-.769A17 17 0 0 0 0-1.386",
    style: {
      fill: "#958767",
      fillRule: "nonzero"
    },
    transform: "translate(147.007 190.81)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-7.395A11.6 11.6 0 0 0-2.559-.123V0A16.8 16.8 0 0 0 0-7.395",
    style: {
      fill: "#958767",
      fillRule: "nonzero"
    },
    transform: "translate(161.873 223.22)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-9.489a16.9 16.9 0 0 0-4.284 3.116 16.9 16.9 0 0 0-3.338 4.738A7.86 7.86 0 0 0-2.816 0a7.85 7.85 0 0 0 5.068-1.847A7.25 7.25 0 0 1-.307-7.404 7.3 7.3 0 0 1 0-9.489",
    style: {
      fill: "#5c99b1",
      fillRule: "nonzero"
    },
    transform: "translate(128.089 202.995)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.537c-.726.044-1.285.684-2.026.684-.144 0-.294-.024-.454-.081h-.033c-.523 0-1.067.128-1.611.257-.543.128-1.087.256-1.61.256q-.074 0-.148-.004l-.038.015a12.4 12.4 0 0 1-4.256 6.747q.531.29 1.027.663c.402-.544.849-1.066 1.343-1.558A13.7 13.7 0 0 1 1.92-5.587h.013A8.1 8.1 0 0 0 .068-8.474z",
    style: {
      fill: "#8a9590",
      fillRule: "nonzero"
    },
    transform: "translate(270.212 128.963)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.968q-.522.299-1.066.542A8.2 8.2 0 0 0 .853 0l.105-.279A16 16 0 0 1 0-2.968",
    style: {
      fill: "#847e65",
      fillRule: "nonzero"
    },
    transform: "translate(253.825 133.741)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.295-3.871q.67.792 1.441 1.447A16 16 0 0 1-.295.04a13.7 13.7 0 0 0-1.132-3.45 8 8 0 0 1 1.132-.461",
    style: {
      fill: "#7d6d54",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-10.712 422.09 1031.67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-7.853c-1.315 0-2.63.502-3.634 1.505A5.13 5.13 0 0 0-5.139-2.69c.004.935.263 1.869.774 2.69A12 12 0 0 1-1.84-.734a13.9 13.9 0 0 1 3.702-6.609l.117-.115A5.2 5.2 0 0 0 0-7.853",
    style: {
      fill: "#8a9590",
      fillRule: "nonzero"
    },
    transform: "translate(125.27 104.818)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.955A35 35 0 0 1-1.959 0 5.1 5.1 0 0 0 0-.955",
    style: {
      fill: "#627673",
      fillRule: "nonzero"
    },
    transform: "translate(211.192 166.843)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-21.166q-.56.044-1.113.137c-.963 1.036.386 3.223-1.341 4.163-.145.425-.654.609-.801 1.055l-.065-.003c-.65 0-1.075.815-1.141 1.386.074.343-.148.57-.424.745-.154.098-.421.109-.326.42-.267.316-.663.525-1.072.737a35.3 35.3 0 0 1 1.204 6.741A18.57 18.57 0 0 1 3.942 0a8 8 0 0 1 1.283-.04 8.12 8.12 0 0 1 2.078-6.559l.06-.165c-.82-.554-1.497-1.237-1.88-1.973-.132-.362-.573-.501-.338-.989.069-.161.081-.574-.346-.597-.076-.589.015-1.197-.685-1.46 1.134-.408.097-1.735-.52-2.178-.263-.147-.553-.533-.279-.752.746-.551-.066-.978-.003-1.608.191-.642-.407-.981-.448-1.532-.009-1.058-1.132-1.952-1.935-2.484-.494-.055-.669-.47-.929-.829",
    style: {
      fill: "#99c2d2",
      fillRule: "nonzero"
    },
    transform: "translate(243.969 126.72)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.165-.06 0l.121-.126z",
    style: {
      fill: "#9ea097",
      fillRule: "nonzero"
    },
    transform: "translate(254.141 117.603)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.787q-.451 0-.901.049A18.4 18.4 0 0 1 1.04 0l.185-.082a8.1 8.1 0 0 1-.842-2.696A8 8 0 0 0 0-2.787",
    style: {
      fill: "#958767",
      fillRule: "nonzero"
    },
    transform: "translate(250.66 130.503)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-9.199a35.3 35.3 0 0 1-.255 7.832A12.4 12.4 0 0 0 3.167 0a8.5 8.5 0 0 1 .874-1.027 8.28 8.28 0 0 1 4.98-2.387A18.57 18.57 0 0 0 0-9.199",
    style: {
      fill: "#6ba2b9",
      fillRule: "nonzero"
    },
    transform: "translate(236.953 131.436)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.746a8.28 8.28 0 0 0-4.98 2.387 8.5 8.5 0 0 0-.874 1.026 12.55 12.55 0 0 0 7.794-.675A18.4 18.4 0 0 0 0-3.746",
    style: {
      fill: "#777661",
      fillRule: "nonzero"
    },
    transform: "translate(249.415 131.895)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.773a8.13 8.13 0 0 0-2.077 6.56A8.3 8.3 0 0 1-.545 0 16.2 16.2 0 0 1 0-6.773",
    style: {
      fill: "#4c8faa",
      fillRule: "nonzero"
    },
    transform: "translate(254.058 126.96)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-7.687-.121.126A16.15 16.15 0 0 0-.667-.788C.045-.621.739-.358 1.396 0q.499-.405.964-.87a12.4 12.4 0 0 0 3.292-5.877c-.51.237-1.089.344-1.697.344-1.323 0-2.78-.507-3.955-1.284",
    style: {
      fill: "#617a7f",
      fillRule: "nonzero"
    },
    transform: "translate(254.225 128.048)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.775-2.99A8.1 8.1 0 0 1 1.932-.413q-.568.179-1.157.302A16 16 0 0 0-.23-1.814 8 8 0 0 1 .775-2.99",
    style: {
      fill: "#62695b",
      fillRule: "nonzero"
    },
    transform: "matrix(-1.03408 .91604 .91604 1.03408 254.728 129.047)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.941Q.129-.961.377 0a12.4 12.4 0 0 0 1.685-1.154A8.3 8.3 0 0 0 0-1.941",
    style: {
      fill: "#5f5d4f",
      fillRule: "nonzero"
    },
    transform: "translate(253.304 129.641)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.874q-.152.01-.304.01l-.085-.001A10.23 10.23 0 0 0 1.462 0l.14-.064A23.4 23.4 0 0 1 0-4.874",
    style: {
      fill: "#648f7d",
      fillRule: "nonzero"
    },
    transform: "translate(239.642 186.312)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-.643-.139.064q.21.296.446.579A22 22 0 0 1 0-.643",
    style: {
      fill: "#646d4f",
      fillRule: "nonzero"
    },
    transform: "translate(241.855 187.112)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-16.92c-.998.317-1.968.748-2.888 1.295a15.55 15.55 0 0 1 .934 9.762A12.2 12.2 0 0 1 1.36-3.508 12.1 12.1 0 0 1 3.806 0a34.9 34.9 0 0 1 4.92-12.288 13.7 13.7 0 0 1-8.07-3.93A14 14 0 0 1 0-16.92",
    style: {
      fill: "#99c2d2",
      fillRule: "nonzero"
    },
    transform: "translate(135.627 113.306)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-9.762A14 14 0 0 0-2.63-7.74 5.1 5.1 0 0 1-.976-6.629 5.12 5.12 0 0 1 .53-2.984 5.15 5.15 0 0 1-.141-.455Q.404-.255.933 0c.261-1.14.392-2.304.392-3.469A15.5 15.5 0 0 0 0-9.762",
    style: {
      fill: "#9ea097",
      fillRule: "nonzero"
    },
    transform: "translate(131.637 105.207)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-7.284-.116.115A13.9 13.9 0 0 0-3.819-.56 12.2 12.2 0 0 1 2.489 0a5.13 5.13 0 0 0 .671-2.528 5.12 5.12 0 0 0-1.505-3.645A5.1 5.1 0 0 0 0-7.284",
    style: {
      fill: "#617a7f",
      fillRule: "nonzero"
    },
    transform: "translate(128.004 104.577)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-16.731a8.05 8.05 0 0 1-3.511 2.662c-2.389 3.801-1.93 8.88 1.379 12.188A9.8 9.8 0 0 0 .518 0c.01-.245.262-.489.3-.726-.217-.627.043-2.228-.577-2.388C.935-7.432.135-12.121 0-16.731",
    style: {
      fill: "#7fb2c7",
      fillRule: "nonzero"
    },
    transform: "translate(175.446 271.699)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-10.902A5.958 5.958 0 0 0-3.318 0a13.18 13.18 0 0 1 8.685-2.361A5.958 5.958 0 0 0 0-10.902",
    style: {
      fill: "#99c2d2",
      fillRule: "nonzero"
    },
    transform: "translate(63.37 128.282)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.415a13.17 13.17 0 0 0-7.605 2.406A5.94 5.94 0 0 0-4.287 0 5.94 5.94 0 0 0-.076-1.745 6 6 0 0 0 1.08-3.371Q.54-3.415 0-3.415",
    style: {
      fill: "#7aacc2",
      fillRule: "nonzero"
    },
    transform: "translate(69.293 129.678)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-20.903a16.9 16.9 0 0 0-4.973 3.446 16.9 16.9 0 0 0-3.025 4.11 13.7 13.7 0 0 1 4.866 3.146A13.7 13.7 0 0 1 .889 0a35.2 35.2 0 0 1 13.287-2.966 18 18 0 0 1 1.681-3.773c-.17-.335-.368-.657-.503-.951-.092-.712-.642-.859-1.108-1.065-.63-.219-.075-.419-.02-.893l-.594.156a.7.7 0 0 0-.005-.478 16.94 16.94 0 0 1-9.695-4.809A17 17 0 0 1 0-20.903",
    style: {
      fill: "#99c2d2",
      fillRule: "nonzero"
    },
    transform: "translate(167.733 78.119)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.086c-.513.282-1.094.484-1.283 1.158-.29.328-1.204.366-1.401.739-.991 1.274-3.068 1.422-3.875 2.844a2 2 0 0 1-.166.008c-.929 0-.918-.8-1.14-1.395.627-.668.405-1.383.069-2.044a18 18 0 0 0-1.681 3.773q.447-.012.894-.012C-5.76-1.015-2.937-.676-.18 0c.248-1.158.371-2.336.372-3.514q0-1.292-.192-2.572",
    style: {
      fill: "#958767",
      fillRule: "nonzero"
    },
    transform: "translate(200.409 75.407)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.224a8.4 8.4 0 0 1-1.385 1.826A8.3 8.3 0 0 1-4.29-.506 2.94 2.94 0 0 0-.563-.859 2.94 2.94 0 0 0 0-4.224",
    style: {
      fill: "#7fb2c7",
      fillRule: "nonzero"
    },
    transform: "translate(82.322 86.906)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.051-.016 0l.058-.018z",
    style: {
      fill: "#dee898",
      fillRule: "nonzero"
    },
    transform: "translate(261.631 141.631)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-14.739c.35.929.523 1.909.521 2.889a8.12 8.12 0 0 1-2.386 5.744 8.12 8.12 0 0 1-5.76 2.387l-.233-.004q.09.607.089 1.218a8.4 8.4 0 0 1-.375 2.472l.042.033a23.6 23.6 0 0 1 7.059-1.078c1.584 0 3.165.169 4.723.486.912-2.754 2.344-5.494 3.119-8.016.243-1.188.825-2.338 1.324-3.449A13.72 13.72 0 0 0 0-14.739",
    style: {
      fill: "#cbc171",
      fillRule: "nonzero"
    },
    transform: "translate(272.882 141.606)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-7.622a14 14 0 0 0-.441 1.465A18.8 18.8 0 0 1 .383-.684Q.383-.341.37 0a23.4 23.4 0 0 1 4.411-1.911l.016-.051q-.75-.59-1.443-1.282A16.2 16.2 0 0 1 .396-7.301 9 9 0 0 1 0-7.622",
    style: {
      fill: "#bea153",
      fillRule: "nonzero"
    },
    transform: "translate(255.004 144.271)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.339A16.1 16.1 0 0 0 4.401 0a8.3 8.3 0 0 0 .286-3.69A8.12 8.12 0 0 1 0-5.339",
    style: {
      fill: "#ae8a49",
      fillRule: "nonzero"
    },
    transform: "translate(255.551 141.56)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.615A13.8 13.8 0 0 0 .031 0q.387-.237.781-.458.012-.342.012-.684.002-1.49-.246-3.006A19 19 0 0 0 0-6.615",
    style: {
      fill: "#928752",
      fillRule: "nonzero"
    },
    transform: "translate(254.394 144.904)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-11.02h-.013a13.7 13.7 0 0 0-9.726 4.029 13.6 13.6 0 0 0-1.343 1.558q.458.346.876.763A8.28 8.28 0 0 1-7.858-.004l.233.004c2.085 0 4.17-.796 5.76-2.387A8.12 8.12 0 0 0 .521-8.131 8.2 8.2 0 0 0 0-11.02",
    style: {
      fill: "#7b8b68",
      fillRule: "nonzero"
    },
    transform: "translate(272.882 136.468)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-.599-.105.279q.194.167.396.32A17 17 0 0 1 0-.599",
    style: {
      fill: "#777952",
      fillRule: "nonzero"
    },
    transform: "translate(255.149 134.184)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.429a13.7 13.7 0 0 0-1.754 3.18q.14.302.291.6A8.12 8.12 0 0 0 3.225 0 8.3 8.3 0 0 0 .877-4.666 8.5 8.5 0 0 0 0-5.429",
    style: {
      fill: "#706a48",
      fillRule: "nonzero"
    },
    transform: "translate(257.572 136.463)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-11.6A13.8 13.8 0 0 0 1.27-.872a11.4 11.4 0 0 1 2.685-.321c1.737 0 3.476.398 5.065 1.193a31 31 0 0 1 2.267-3.096 21.4 21.4 0 0 1-6.95-6.303A35 35 0 0 1 0-11.6",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(163.645 180.274)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.303A21.4 21.4 0 0 0 6.95 0a31 31 0 0 1 3.609-3.676A35.1 35.1 0 0 1 0-6.303",
    style: {
      fill: "#bbb255",
      fillRule: "nonzero"
    },
    transform: "translate(169.637 175.996)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-9.067a31 31 0 0 0-2.267 3.096A11.3 11.3 0 0 1 .678-3.845 11.3 11.3 0 0 1 3.206 0a13.7 13.7 0 0 0 8.436-3.969A13.8 13.8 0 0 0 13.7-6.594c-1.089.17-2.188.255-3.287.255-3.596 0-7.192-.91-10.413-2.728",
    style: {
      fill: "#a3bc71",
      fillRule: "nonzero"
    },
    transform: "translate(179.238 188.522)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-7.412a35.3 35.3 0 0 1-12.062 1.009 31 31 0 0 0-3.609 3.675A21.2 21.2 0 0 0-5.258 0q1.652 0 3.287-.254A13.74 13.74 0 0 0 0-7.354z",
    style: {
      fill: "#989655",
      fillRule: "nonzero"
    },
    transform: "translate(200.887 179.764)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-15.148A8.092 8.092 0 0 0 6.875-.541a9.9 9.9 0 0 1 3.494-3.335 30 30 0 0 1 .126-3.385c-.065-.707-.528-1.463-.125-2.203-.057-.194-.083-.396-.124-.594-.2.01-.4.027-.601.027-2.98 0-5.96-1.137-8.233-3.41A12 12 0 0 1 0-15.148",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(161.098 253.011)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.154a8.13 8.13 0 0 0-3.973 1.037q.611.905 1.412 1.707A11.6 11.6 0 0 0 5.672 0c.2 0 .4-.017.601-.027-.22-1.062-.232-2.161-.088-3.246a8 8 0 0 0-1.644-1.482A8.06 8.06 0 0 0 0-6.154",
    style: {
      fill: "#b39f49",
      fillRule: "nonzero"
    },
    transform: "translate(166.588 239.153)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.733-4.076a9.84 9.84 0 0 1 0 4.83 8.05 8.05 0 0 1-.498-4.378q.251-.225.498-.452",
    style: {
      fill: "#789c6b",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-46.334 149.874 233.945)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-16.711A8.356 8.356 0 1 0 3.004-.556a2.92 2.92 0 0 1-1.286-2.429c0-.752.286-1.503.86-2.077a2.93 2.93 0 0 1 2.076-.86 2.93 2.93 0 0 1 2.639 1.649A8.36 8.36 0 0 0 0-16.711",
    style: {
      fill: "#dee898",
      fillRule: "nonzero"
    },
    transform: "translate(72.247 86.974)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.366c-.751 0-1.503.287-2.076.86a2.93 2.93 0 0 0-.861 2.077A2.93 2.93 0 0 0-1.65 0a8.3 8.3 0 0 0 2.904-1.891 8.3 8.3 0 0 0 1.385-1.827A2.93 2.93 0 0 0 0-5.366",
    style: {
      fill: "#7ca287",
      fillRule: "nonzero"
    },
    transform: "translate(78.677 86.206)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-24.004a13.7 13.7 0 0 0-9.727 4.029c-5.144 5.144-5.362 13.349-.655 18.753 1.373-.436 2.8-.653 4.227-.653 2.419 0 4.838.625 6.993 1.875a35.8 35.8 0 0 1 5.4-5.264 16.84 16.84 0 0 1-3.297-10.012A16.9 16.9 0 0 1 4.86-23.12 13.8 13.8 0 0 0 0-24.004",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(149.97 91.62)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.285c-1.427 0-2.854.218-4.228.653q.313.36.656.702A13.7 13.7 0 0 0 4.498 0a35 35 0 0 1 2.495-3.409A13.9 13.9 0 0 0 0-5.285",
    style: {
      fill: "#8aa970",
      fillRule: "nonzero"
    },
    transform: "translate(141.467 96.33)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-17.857a16.9 16.9 0 0 0-1.92 7.844A16.84 16.84 0 0 0 1.378 0a35 35 0 0 1 7.51-4.51q.008-.215.008-.431a13.7 13.7 0 0 0-4.029-9.77A13.7 13.7 0 0 0 0-17.857",
    style: {
      fill: "#8aa970",
      fillRule: "nonzero"
    },
    transform: "translate(156.684 84.35)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.254C-.502-.838-1.043-.457-1.483 0A19 19 0 0 1 .135-.185C.069-.539.036-.897 0-1.254",
    style: {
      fill: "#eaf0c0",
      fillRule: "nonzero"
    },
    transform: "translate(228.16 118.073)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-52.864a16.9 16.9 0 0 1-7.757 1.883c-1.398 0-2.795-.173-4.158-.518q-.285.427-.661.804a5.3 5.3 0 0 1-3.766 1.56 5.3 5.3 0 0 1-4.098-1.925 13.6 13.6 0 0 1-2.853 1.313 13.9 13.9 0 0 1 3.505 9.237 13.9 13.9 0 0 1-4.085 9.87 13.9 13.9 0 0 1-10.362 4.077q-.146.308-.31.606a35 35 0 0 0 10.04 20.63A35.2 35.2 0 0 0-17.682 0q.279-.958.702-1.876a8.77 8.77 0 0 1-4.382-2.386 8.78 8.78 0 0 1-2.581-6.228c0-2.255.861-4.509 2.581-6.229a8.78 8.78 0 0 1 6.228-2.58l.113.001a21.2 21.2 0 0 1 4.05-5.657 21.1 21.1 0 0 1 7.827-4.967 13.26 13.26 0 0 1 1.215-9.839 4.08 4.08 0 0 1-2.096-3.561c0-1.042.397-2.084 1.192-2.879a4.06 4.06 0 0 1 2.879-1.192c1.042 0 2.084.397 2.878 1.192.318.317.572.674.763 1.054q.747-.375 1.526-.65a18 18 0 0 1-1.248-1.14A18.2 18.2 0 0 1 0-52.864",
    style: {
      fill: "#eaf0c0",
      fillRule: "nonzero"
    },
    transform: "translate(188.072 164.249)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-28.624a21.1 21.1 0 0 0-7.827 4.967A21.2 21.2 0 0 0-11.877-18a8.78 8.78 0 0 1 6.117 2.579 8.78 8.78 0 0 1 2.549 6.965 14 14 0 0 1 1.876-.128c3.52 0 7.041 1.343 9.727 4.029A13.7 13.7 0 0 1 11.415 0q.214-.066.428-.129a5.1 5.1 0 0 1-.283-1.698 5.12 5.12 0 0 1 1.505-3.622 5.12 5.12 0 0 1 3.276-1.493 18.7 18.7 0 0 1-1.342-6.987c.003-1.216.126-2.412.36-3.575l-.216-.21a10 10 0 0 1-1.009-1.183q-.682.07-1.368.071a13.17 13.17 0 0 1-9.343-3.871A13.13 13.13 0 0 1 0-28.624",
    style: {
      fill: "#d1bc7a",
      fillRule: "nonzero"
    },
    transform: "translate(183.728 162.456)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-18.513a16.8 16.8 0 0 1-4.569 8.383A16.9 16.9 0 0 1-8.75-7.067 18.2 18.2 0 0 0-4.786-1.14q.604.605 1.249 1.14A13.3 13.3 0 0 1 .701-.753a8.87 8.87 0 0 1-2.34-6.039 8.88 8.88 0 0 1 2.607-6.271 8.88 8.88 0 0 1 6.674-2.598A35 35 0 0 0 0-18.513",
    style: {
      fill: "#c8a65d",
      fillRule: "nonzero"
    },
    transform: "translate(200.16 100.982)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.704q-.33.382-.693.745a13.8 13.8 0 0 1-2.586 2.034q.156.188.333.365A5.3 5.3 0 0 0 .819 0a5.31 5.31 0 0 0 4.427-2.364A16.8 16.8 0 0 1 0-4.704",
    style: {
      fill: "#c8a65d",
      fillRule: "nonzero"
    },
    transform: "translate(164.365 96.37)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-15.875q-.78.275-1.527.65a4.1 4.1 0 0 1 .431 1.823 4.06 4.06 0 0 1-1.193 2.881 4.06 4.06 0 0 1-2.879 1.192 4.1 4.1 0 0 1-1.975-.51 13.2 13.2 0 0 0-1.661 6.4A13.3 13.3 0 0 0-8.358 0a21.2 21.2 0 0 1 7.163-1.242c2.079 0 4.159.304 6.166.913a9.7 9.7 0 0 1 1.814-2.508 9.7 9.7 0 0 1 2-1.526c.272-.281.507-.649.465-.916-.206-.448.319-.641.228-.968-.096-.337.072-.579.185-.845.522-1.533.519-3.004 1.016-4.47l.081-.145C6.921-11.895 3.127-13.274 0-15.875",
    style: {
      fill: "#7fa7a2",
      fillRule: "nonzero"
    },
    transform: "translate(195.274 122.913)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-11.04c-2.426 0-4.852.414-7.163 1.242A13.16 13.16 0 0 0-3.74-3.871a13.18 13.18 0 0 0 10.711 3.8 9.7 9.7 0 0 1-1.838-5.677 9.7 9.7 0 0 1 1.033-4.38A21.3 21.3 0 0 0 0-11.04",
    style: {
      fill: "#7f876d",
      fillRule: "nonzero"
    },
    transform: "translate(193.624 136.449)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.921a13.2 13.2 0 0 0-4.238.753C-1.111-1.567 2.682-.188 6.522 0c.224-.471.001-1.069-.04-1.542q.231-.24.401-.508c-.107.003-.215.014-.321.014A8.87 8.87 0 0 1 0-4.921",
    style: {
      fill: "#7b7a5b",
      fillRule: "nonzero"
    },
    transform: "translate(201.129 106.74)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.035-2.072a5.14 5.14 0 0 0 0 2.586 35 35 0 0 1-1.069-2.552q.534-.001 1.069-.034",
    style: {
      fill: "#a9a076",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-37.189 100.853 287.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.246q-.215.063-.428.129A13.8 13.8 0 0 1 .577 0a35 35 0 0 0 5.5-1.941 5 5 0 0 1-1.222.147 5.12 5.12 0 0 1-3.634-1.504A5.1 5.1 0 0 1 0-5.246",
    style: {
      fill: "#a9a076",
      fillRule: "nonzero"
    },
    transform: "translate(200.089 169.525)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-28.912c-.537.036-1.076.103-1.618.186-.25.26-.468.545-.622.878h-.04a1.2 1.2 0 0 0-.728.23 9.7 9.7 0 0 1 2.442 6.434 9.67 9.67 0 0 1-2.842 6.871 9.8 9.8 0 0 1-1.915 1.49A21.3 21.3 0 0 1-4.599 0q.325-.31.645-.629a35 35 0 0 0 9.93-19.792 12.5 12.5 0 0 1-2.531-1.955A12.43 12.43 0 0 1 0-28.912",
    style: {
      fill: "#acc3b2",
      fillRule: "nonzero"
    },
    transform: "translate(228.346 157.758)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-16.445a18.3 18.3 0 0 0-.113 6.632C.112-8.438.483-7.123.983-5.882q.178-.012.356-.013a5.12 5.12 0 0 1 3.634 1.506 5.12 5.12 0 0 1 1.484 4.1c1.054.043 2.11.139 3.156.289a35 35 0 0 0 2.727-2.341c.439-1.717.659-3.477.661-5.238a21.2 21.2 0 0 0-1.386-7.585 9.7 9.7 0 0 1-4.958 1.357A9.7 9.7 0 0 1 0-16.445",
    style: {
      fill: "#a09a74",
      fillRule: "nonzero"
    },
    transform: "translate(204.946 160.993)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.529-2.445c.152.494.378.968.675 1.401q-.325.424-.675.829A35 35 0 0 1-.5-1.514a31 31 0 0 1 3.029-.931",
    style: {
      fill: "#83876e",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(11.849 -648.036 -701.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.812a5.12 5.12 0 0 0-3.277 1.493c-1 1-1.502 2.31-1.504 3.621-.002.575.093 1.15.283 1.698a31 31 0 0 1 8.019-1.237A18.4 18.4 0 0 1 0-6.812",
    style: {
      fill: "#6e7e6a",
      fillRule: "nonzero"
    },
    transform: "translate(206.303 162.277)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.689c-2.705.06-5.402.473-8.019 1.237a5.1 5.1 0 0 0 1.222 1.948A5.12 5.12 0 0 0-3.164 0c.411 0 .822-.048 1.223-.147a35 35 0 0 0 1.959-.955q.235-.185.451-.402a5.1 5.1 0 0 0 1.112-1.658A18 18 0 0 1 0-4.689",
    style: {
      fill: "#5c7263",
      fillRule: "nonzero"
    },
    transform: "translate(211.167 167.046)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.605q-.178 0-.357.013A18.4 18.4 0 0 0 3.164-.017q.345-.008.691-.008.63 0 1.263.025.021-.24.021-.482A5.12 5.12 0 0 0 3.633-4.1 5.12 5.12 0 0 0 0-5.605",
    style: {
      fill: "#587062",
      fillRule: "nonzero"
    },
    transform: "translate(206.796 160.592)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.148-1.576q.299-.173.602-.339Q.512-.838.148.199A5.1 5.1 0 0 1-.931-.92q.534-.34 1.079-.656",
    style: {
      fill: "#4d665d",
      fillRule: "nonzero"
    },
    transform: "matrix(-1.19531 .6926 .6926 1.19531 213.391 162.338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.741c-.554.286-1.131.578-1.446 1.149-.48.878-1.889 1.232-1.627 2.419-.783.065-.749.099-1.253.618a5.4 5.4 0 0 1-.835.827c.036.357.069.715.135 1.069q.609-.04 1.212-.039c1.726 0 3.411.242 5.018.698A35 35 0 0 0 0-6.741",
    style: {
      fill: "#98b6ac",
      fillRule: "nonzero"
    },
    transform: "translate(235.289 118.728)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.53q-.603 0-1.212.039a12.43 12.43 0 0 0 3.445 6.536A12.6 12.6 0 0 0 4.764 0a35.4 35.4 0 0 0 .254-7.832A18.4 18.4 0 0 0 0-8.53",
    style: {
      fill: "#719a9a",
      fillRule: "nonzero"
    },
    transform: "translate(230.02 129.547)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-23.193a13.8 13.8 0 0 1-5.945.583 34.9 34.9 0 0 0-4.92 12.288 12.1 12.1 0 0 1 1.108 5.081 12.15 12.15 0 0 1-1.185 5.232q.25.009.499.009c3.57 0 7.139-1.362 9.863-4.086a13.9 13.9 0 0 0 4.085-9.869A13.9 13.9 0 0 0 0-23.193",
    style: {
      fill: "#98b6ac",
      fillRule: "nonzero"
    },
    transform: "translate(155.894 127.566)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-14.332a35.2 35.2 0 0 0-13.287 2.966 14 14 0 0 1-.43 2.982 5.3 5.3 0 0 1 1.687 1.139 5.3 5.3 0 0 1 1.56 3.778 5.3 5.3 0 0 1-.898 2.949C-10.005-.173-8.608 0-7.21 0-4.544 0-1.878-.628.547-1.883A18.3 18.3 0 0 1 0-14.332",
    style: {
      fill: "#98b6ac",
      fillRule: "nonzero"
    },
    transform: "translate(187.317 93.82)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-12.46q-.447 0-.894.011A18.3 18.3 0 0 0-.347 0a16.9 16.9 0 0 0 4.181-3.063 16.8 16.8 0 0 0 4.569-8.383A35.3 35.3 0 0 0 0-12.46",
    style: {
      fill: "#8c825b",
      fillRule: "nonzero"
    },
    transform: "translate(188.552 91.219)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-7.867a13.7 13.7 0 0 1-2.897 5.526A16.8 16.8 0 0 0 2.349 0c.596-.89.896-1.919.898-2.95a5.3 5.3 0 0 0-1.559-3.778A5.3 5.3 0 0 0 0-7.867",
    style: {
      fill: "#8c825b",
      fillRule: "nonzero"
    },
    transform: "translate(168.367 93.106)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-17.423c-2.255 0-4.509.86-6.228 2.58a8.78 8.78 0 0 0-2.581 6.229c0 2.254.861 4.508 2.581 6.228A8.76 8.76 0 0 0-1.847 0q.363-.792.833-1.543a21.2 21.2 0 0 1-1.031-6.569 21.2 21.2 0 0 1 2.158-9.31z",
    style: {
      fill: "#7fa7a2",
      fillRule: "nonzero"
    },
    transform: "translate(167.165 161.658)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-15.879a21.2 21.2 0 0 0-2.158 9.31A21.2 21.2 0 0 0-1.126 0 14 14 0 0 1 .813-2.434a13.7 13.7 0 0 1 7.853-3.901q.032-.38.03-.761a8.78 8.78 0 0 0-2.58-6.204A8.78 8.78 0 0 0 0-15.879",
    style: {
      fill: "#7f876d",
      fillRule: "nonzero"
    },
    transform: "translate(167.321 159.525)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.242-1.925q.672.497 1.397.906a10 10 0 0 1-1.397.683l-.282.106q.18-.844.282-1.695",
    style: {
      fill: "#adad4e",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-23.468 166.553 403.377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.433a9.7 9.7 0 0 0-2 1.526 9.7 9.7 0 0 0-1.814 2.508c1.18.358 2.333.831 3.449 1.399.097-.663-.349-1.454-.461-2.044.457-.423.889-.61.887-1.167.437-.307.113-.677-.079-.951.498-.509-.231-.645-.325-.977.111-.07.229-.176.343-.294",
    style: {
      fill: "#709861",
      fillRule: "nonzero"
    },
    transform: "translate(207.411 124.391)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-10.057a9.7 9.7 0 0 0-1.033 4.379A9.7 9.7 0 0 0 .805 0a13 13 0 0 0 1.642-.275c.199-.662.439-1.308.709-1.94L2.24-3.984l-.159.01.404-.933c-.036-.088-.109-.257-.183-.431l.518-.22-.445-.278c1.227-.484-.056-2.408.453-2.408.076 0 .193.043.366.142.152-.167.226-.356.255-.556A21 21 0 0 0 0-10.057",
    style: {
      fill: "#6d7d4e",
      fillRule: "nonzero"
    },
    transform: "translate(202.142 136.351)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-14.795c-.55.4-.76 1.227-1.337 1.662a68 68 0 0 0-3.331 3.137 13.2 13.2 0 0 1-2.03 3.015A21.1 21.1 0 0 1-2.315 0 9.8 9.8 0 0 0-.4-1.491a9.66 9.66 0 0 0 2.842-6.871A9.7 9.7 0 0 0 0-14.795",
    style: {
      fill: "#8fb062",
      fillRule: "nonzero"
    },
    transform: "translate(224.191 140.044)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.338q-.233.258-.482.507A13.2 13.2 0 0 1-3.22-5.734c-.46.569-.953 1.081-1.385 1.081a.57.57 0 0 1-.426-.206q-.877.342-1.785.553a18 18 0 0 0-.417 1.668A9.7 9.7 0 0 0-.576 0a9.7 9.7 0 0 0 4.958-1.357A21.1 21.1 0 0 0 0-8.338",
    style: {
      fill: "#878f4f",
      fillRule: "nonzero"
    },
    transform: "translate(214.938 141.919)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.095-3.457q.035 1.775.028 3.559l-.028-.001q-.316.007-.631.022c.042-1.246.266-2.444.631-3.58",
    style: {
      fill: "#5a835a",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-43.941 38.18 237.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.939A19 19 0 0 0-.709 0a13 13 0 0 0 1.785-.553 1.7 1.7 0 0 1-.315-.559c-.146-.424-.397-.741-.728-.764z",
    style: {
      fill: "#586f4c",
      fillRule: "nonzero"
    },
    transform: "translate(206.502 135.97)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.076q-.818.856-1.641 1.721c-.295.258-.693.83-1.118 1.355a13.2 13.2 0 0 0 3.22-2.604 21 21 0 0 0-.44-.453z",
    style: {
      fill: "#586f4c",
      fillRule: "nonzero"
    },
    transform: "translate(214.302 133.998)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.206-4.537q.925.405 1.772.934A35 35 0 0 1 1.206.926a21 21 0 0 0-.978-4.339q.536-.52.978-1.124",
    style: {
      fill: "#c1da60",
      fillRule: "nonzero"
    },
    transform: "matrix(-1.03101 .9195 .9195 1.03101 170.029 165.226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-14.71c-.626 0-1.254.043-1.876.128a8.77 8.77 0 0 1-2.549 5.493 8.78 8.78 0 0 1-6.598 2.572 21 21 0 0 0 2.158 3.89A35.2 35.2 0 0 0 1.694 0 30.7 30.7 0 0 1 12.75-6.126a13.7 13.7 0 0 0-3.023-4.555A13.7 13.7 0 0 0 0-14.71",
    style: {
      fill: "#adad4e",
      fillRule: "nonzero"
    },
    transform: "translate(181.884 170.919)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.685-9.017A30.7 30.7 0 0 1-3.634 3.455a35.3 35.3 0 0 1-6.689-10.087 13.8 13.8 0 0 1 4.638-2.385",
    style: {
      fill: "#8d924f",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-51.669 55.708 197.553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.73q-.47.751-.833 1.543Q-.101-.032.645 0A21 21 0 0 1 0-1.73",
    style: {
      fill: "#709861",
      fillRule: "nonzero"
    },
    transform: "translate(165.765 161.916)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.073a13.7 13.7 0 0 0-7.852 3.901 14 14 0 0 0-1.94 2.434q.284.877.645 1.731.184.007.369.007c2.254 0 4.508-.86 6.229-2.58A8.77 8.77 0 0 0 0-8.073",
    style: {
      fill: "#6d7d4e",
      fillRule: "nonzero"
    },
    transform: "translate(179.292 161.926)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.09a35.7 35.7 0 0 0-5.4 5.264A14 14 0 0 1-1.95 0C-.962-.323-.005-.76.903-1.312A5.3 5.3 0 0 1-.324-4.706 5.3 5.3 0 0 1 .46-7.497 17 17 0 0 1 0-8.09",
    style: {
      fill: "#c1da60",
      fillRule: "nonzero"
    },
    transform: "translate(158.587 95.525)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.185a5.3 5.3 0 0 0-.784 2.791A5.3 5.3 0 0 0 .443 0a13.8 13.8 0 0 0 3.279-2.78A17 17 0 0 1 0-6.185",
    style: {
      fill: "#a59a45",
      fillRule: "nonzero"
    },
    transform: "translate(159.223 93.712)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.508A35 35 0 0 0-2.495-.099Q-1.669 0-.838 0C.611 0 2.06-.227 3.45-.682q-.28-.315-.58-.616A14 14 0 0 0 0-3.508",
    style: {
      fill: "#80a561",
      fillRule: "nonzero"
    },
    transform: "translate(151.127 96.467)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.102A35 35 0 0 0-7.51-.593q.223.301.46.593a5.4 5.4 0 0 1 .776-.982A5.34 5.34 0 0 1-.431-2.121c.253-.978.396-1.978.431-2.981",
    style: {
      fill: "#80a561",
      fillRule: "nonzero"
    },
    transform: "translate(168.962 85.167)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.947c-1.363 0-2.726.52-3.765 1.56a5.4 5.4 0 0 0-.776.982q.552.682 1.187 1.317C-2.563-1.297-1.714-.601-.819 0a13.7 13.7 0 0 0 2.897-5.526A5.3 5.3 0 0 0 0-5.947",
    style: {
      fill: "#777b47",
      fillRule: "nonzero"
    },
    transform: "translate(165.497 89.872)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-7.632A4.05 4.05 0 0 0-2.878-6.44a4.06 4.06 0 0 0-1.193 2.879A4.06 4.06 0 0 0-2.878-.682c.275.275.579.502.903.682A13.2 13.2 0 0 1 .233-2.92a13.2 13.2 0 0 1 3.408-2.466A4.08 4.08 0 0 0 0-7.632",
    style: {
      fill: "#c1da60",
      fillRule: "nonzero"
    },
    transform: "translate(188.135 109.321)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.896A13.2 13.2 0 0 0-3.408-3.43 13.3 13.3 0 0 0-5.616-.51a4.07 4.07 0 0 0 4.854-.682A4.06 4.06 0 0 0 .43-4.073c0-.625-.143-1.251-.43-1.823",
    style: {
      fill: "#709861",
      fillRule: "nonzero"
    },
    transform: "translate(193.165 110.025)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-13.404a8.9 8.9 0 0 0-1.22 4.503c0 2.278.868 4.556 2.607 6.294A8.87 8.87 0 0 0 7.681 0c1.458 0 2.913-.36 4.229-1.072-.73-.357-.295-1.211-.788-1.599l.297-.979-.636-.273c.175-.757-.22-1.454-.035-2.213.027-.359-.581-.643-.384-1.071.074-.369.217-.761-.255-1.005-.105-.243.008-.642.005-.93.296-.184.617-.302.65-.742.077-.42.522-.411.667-.811-.62.066-1.241.107-1.864.107-3.332 0-6.665-.939-9.567-2.816",
    style: {
      fill: "#a3bc71",
      fillRule: "nonzero"
    },
    transform: "translate(217.699 225.463)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-7.215a8.87 8.87 0 0 0-6.294 2.608 9 9 0 0 0-1.387 1.791A17.6 17.6 0 0 0 1.886 0C2.509 0 3.13-.042 3.75-.107c.029-.08.05-.17.05-.289.27-.177.597-.234.706-.611.203-.533.626-.593 1.127-.671l-.303-.68a.65.65 0 0 0 .283.076c.485 0 .524-.837.988-.958.302-.038.408-.237.475-.462a9 9 0 0 0-.782-.905A8.87 8.87 0 0 0 0-7.215",
    style: {
      fill: "#90b458",
      fillRule: "nonzero"
    },
    transform: "translate(228.31 210.837)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.615A35 35 0 0 1 4.287 0q.182-.533.36-1.067A8.87 8.87 0 0 0 0-2.615",
    style: {
      fill: "#b39f49",
      fillRule: "nonzero"
    },
    transform: "translate(210.717 82.959)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-16.98a8.88 8.88 0 0 0-6.295 2.607 8.87 8.87 0 0 0-2.607 6.271 8.88 8.88 0 0 0 2.34 6.039l.171-.001c2.468 0 4.936.689 7.092 2.064.391-1.097.398-2.364.638-3.506.337-.286.439-.354.416-.805.03-1.25.363-2.434.652-3.639.737-2.087 1.517-4.236 2.258-6.406a35 35 0 0 0-4.286-2.616A10 10 0 0 0 0-16.98",
    style: {
      fill: "#a59a45",
      fillRule: "nonzero"
    },
    transform: "translate(210.194 102.792)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-2.886-.17.001q.13.141.266.279A8.88 8.88 0 0 0 6.391 0c.107 0 .215-.01.322-.014.163-.254.279-.527.379-.808A13.2 13.2 0 0 0 0-2.886",
    style: {
      fill: "#6b7447",
      fillRule: "nonzero"
    },
    transform: "translate(201.365 103.927)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.183C-.028-.781-.084-.454.133 0 .268-.5.365-.832 0-1.183",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(172.592 39.387)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.79c0 .264-.244.717.137.79.377-.094.087-.528.064-.787z",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(174.072 42.129)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-12.317A17.1 17.1 0 0 0-.191 0a16.9 16.9 0 0 1 6.624-1.481c-.045-.2-.051-.426.004-.691l-.619.311.551-1.344-.103-.089-.98.788c-.325-.715-.202-1.533-.972-1.915l.31-.238c-.381-.049-.549-.293-.75-.55-.312-.19.052-.34.022-.45-1.055-.413-.647-1.706-1.595-2.081-.433-.683-.122-1.306.274-2.007l-.781.643C1.114-10.07.541-11.177 0-12.317",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(167.998 49.242)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-12.414c-2.265.046-4.523.53-6.625 1.481a17 17 0 0 0 3.932 6.124A16.94 16.94 0 0 0 7.002 0c-.093-.253-.298-.421-.222-.74.076-.735-.83-.62-.699-1.268l-.329.312c-.257-.601-1.283-.913-.953-1.549l.526.442.16-.106-.227-.847-.812-.093.297-1.077c-.989-.503-1.434-.324-1.052-1.599L2.676-7.14l.102-1.007-.765-.213c.021-.756.448-1.066-.129-1.754L1.487-9.07c-.511-.646.033-1.303.013-1.981l-.627.678.063-1.005c-.477-.247-.829-.563-.936-1.036",
    style: {
      fill: "#8aa970",
      fillRule: "nonzero"
    },
    transform: "translate(176.885 64.345)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-22.065a11.3 11.3 0 0 0-5.326 2.997 11.28 11.28 0 0 0-3.261 6.879q.605.502 1.172 1.069A16.8 16.8 0 0 1-2.57-1.017C-1.681-.552-.744-.213.214 0a11.6 11.6 0 0 1 2.838-1.33A30.97 30.97 0 0 1 5.415-16.8a13.8 13.8 0 0 1-3.211-2.391A13.8 13.8 0 0 1 0-22.065",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(165.4 209.551)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.42-1.876A11.5 11.5 0 0 1 .048.055a11.3 11.3 0 0 1-3.023-.431q.296-.744.555-1.5",
    style: {
      fill: "#b39f49",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-12.937 608.75 605.028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-15.47A30.97 30.97 0 0 0-2.362 0a11.67 11.67 0 0 1 5.886-.279A11.4 11.4 0 0 0 5.28-1.717a11.3 11.3 0 0 0 3.318-8.009c0-1.416-.263-2.831-.79-4.167q-.645.06-1.291.06c-2.245 0-4.489-.545-6.517-1.637",
    style: {
      fill: "#a3bc71",
      fillRule: "nonzero"
    },
    transform: "translate(172.88 207.714)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.062-2.083a11.7 11.7 0 0 1 1.444 3.209q-.712.363-1.444.689a11.3 11.3 0 0 1-1.517-5.784A11.7 11.7 0 0 1 .062-2.083",
    style: {
      fill: "#928849",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-57.113 76.466 189.926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-11.172q-.057.573-.056 1.151A11.3 11.3 0 0 0 3.261-2.03C4.095-1.196 5.026-.52 6.018 0a16.8 16.8 0 0 0-4.845-10.103Q.605-10.67 0-11.172",
    style: {
      fill: "#8aa970",
      fillRule: "nonzero"
    },
    transform: "translate(153.537 208.146)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.586c-.902 0-1.803.107-2.684.321A13.8 13.8 0 0 0-.48-2.391 13.7 13.7 0 0 0 2.73 0a31 31 0 0 1 2.336-4.393A11.3 11.3 0 0 0 0-5.586",
    style: {
      fill: "#aad04c",
      fillRule: "nonzero"
    },
    transform: "translate(169.108 186.342)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.031a30.6 30.6 0 0 0-2.335 4.394A13.76 13.76 0 0 0 5.472-.061a11.3 11.3 0 0 0-2.527-3.845A11.3 11.3 0 0 0 0-6.031",
    style: {
      fill: "#88b04f",
      fillRule: "nonzero"
    },
    transform: "translate(176.106 188.605)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-17.802a8.87 8.87 0 0 0-6.293 2.607 8.9 8.9 0 0 0 0 12.588A8.87 8.87 0 0 0 0 0a8.9 8.9 0 0 0 4.556-1.252 7.85 7.85 0 0 1 2.306-5.505 7.9 7.9 0 0 1 2.013-1.46 8.88 8.88 0 0 0-2.581-6.978A8.87 8.87 0 0 0 0-17.802",
    style: {
      fill: "#dee898",
      fillRule: "nonzero"
    },
    transform: "translate(107.028 193.758)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.16-7.581c.424.694.746 1.467.941 2.301A7.85 7.85 0 0 1-2.16.615a9 9 0 0 1-.763-2.069 8.86 8.86 0 0 1 .763-6.127",
    style: {
      fill: "#8fae8d",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-31.805 200.77 209.976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-12.947a6.45 6.45 0 0 0-4.577 1.896 6.45 6.45 0 0 0-1.897 4.578 6.45 6.45 0 0 0 1.897 4.577A6.45 6.45 0 0 0 0 0a6.46 6.46 0 0 0 4.578-1.896 6.45 6.45 0 0 0 1.816-3.563 17.5 17.5 0 0 1-3.532-6.823A6.5 6.5 0 0 0 0-12.947",
    style: {
      fill: "#a3bc71",
      fillRule: "nonzero"
    },
    transform: "translate(203.399 209.654)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.534-7.262c.748 2.417.984 5.022.611 7.658A6.46 6.46 0 0 1 .729-5.31c.165-.71.44-1.365.805-1.952",
    style: {
      fill: "#90b458",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38146 1.38146)rotate(31.919 -330.842 -199)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.467c-1.455 0-2.91.433-4.155 1.3A7.9 7.9 0 0 1-2.564-.8a16.9 16.9 0 0 1 9.283.8A7.3 7.3 0 0 0 5.15-2.333 7.26 7.26 0 0 0 0-4.467",
    style: {
      fill: "#b39f49",
      fillRule: "nonzero"
    },
    transform: "translate(137.725 188.895)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.006-.002 0l.006-.002z",
    style: {
      fill: "#8aa970",
      fillRule: "nonzero"
    },
    transform: "translate(128.092 189.885)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.882q-.526.365-.995.834A7.26 7.26 0 0 0-2.819-.004l.005.004a16.8 16.8 0 0 1 4.405-1.514A7.9 7.9 0 0 0 0-3.882",
    style: {
      fill: "#7e7d4a",
      fillRule: "nonzero"
    },
    transform: "translate(131.986 189.883)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.713a11.6 11.6 0 0 1-6.616 2.06 11.7 11.7 0 0 1-2.488-.267 7.84 7.84 0 0 1-2.761 5.18A7.25 7.25 0 0 0-7.142 0a7.26 7.26 0 0 0 5.15-2.134A7.26 7.26 0 0 0 .141-7.293q0-.716-.141-1.42",
    style: {
      fill: "#8aa970",
      fillRule: "nonzero"
    },
    transform: "translate(147.591 202.847)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.559c-1.087 0-2.174.105-3.244.313a7.9 7.9 0 0 1 .602 3.979A11.7 11.7 0 0 0-.154 0c2.316 0 4.632-.687 6.616-2.06a7.3 7.3 0 0 0-.423-1.386A16.9 16.9 0 0 0 0-4.559",
    style: {
      fill: "#7e7d4a",
      fillRule: "nonzero"
    },
    transform: "translate(138.664 193.656)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-7.645-.006.003a7.3 7.3 0 0 0-.308 2.085A7.26 7.26 0 0 0 2.245 0a7.85 7.85 0 0 0 2.762-5.181A11.6 11.6 0 0 1 0-7.645",
    style: {
      fill: "#5f8664",
      fillRule: "nonzero"
    },
    transform: "translate(128.098 200.444)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.031-3.676c1.544.065 3.085.342 4.581.838A11.6 11.6 0 0 1-4.031.349a7.9 7.9 0 0 1 0-4.025",
    style: {
      fill: "#5e6a48",
      fillRule: "nonzero"
    },
    transform: "matrix(-1.36592 .20665 .20665 1.36592 129.43 193.636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-9.967A4.983 4.983 0 1 0 3.524-1.46 4.981 4.981 0 0 0 0-9.967",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(18.135 158.988)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-23.247a9 9 0 0 1-.568.253A18.55 18.55 0 0 1-9.22-11.058q.72.412 1.409.896a10.25 10.25 0 0 1 6.002-1.932c2.63 0 5.26 1.003 7.267 3.01a10.23 10.23 0 0 1 3.004 7.27q0 .912-.161 1.814c.262-.192.536-.376.838-.536l.16-.594.14-.113.244.522c.789-.381 1.205-.911 1.198-1.737l.146-.091a12.2 12.2 0 0 1-.972-4.786 12.15 12.15 0 0 1 3.098-8.12q-.371.02-.744.02a13.7 13.7 0 0 1-9.726-4.03A13.7 13.7 0 0 1 0-23.247",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(255.721 180.576)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.588q.636.13 1.283.212C.775-.986.336-.492 0 .093a10 10 0 0 0-1.038-.372Q-.546-.964 0-1.588",
    style: {
      fill: "#b6d555",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(19.135 -447.59 -462.709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-14.951a13.7 13.7 0 0 1-5.27 1.376 12.16 12.16 0 0 0-3.099 8.12c0 1.63.324 3.26.973 4.786l.05-.033.37.702.947-1.548.115.068-.12.537.134.05 1.128-1.792.533.157C-2.7-4.337-.137-5.369 1.819-6.712c.158-.917.287-1.074 1.012-1.074l.126.001c.098-.167.179-.473.307-.494.495-.084.376-.498.485-.83l.548.141c.377-.503.402-1.204 1.192-1.32l.18-.215c.175-.496.658-.547 1.177-.547l.207.002.214.002c.224 0 .441-.011.629-.062l-.13-.468.56-.421c-.94-.547-2.15-.787-2.475-1.828-.129.033-.357.104-.4.104l-.006-.002c-.091-.235-.217-.301-.355-.301a1 1 0 0 0-.276.055c-.092.027-.182.054-.263.054l-.05-.003c-.721-.743-.897-.885-1.424-.885q-.128 0-.29.009l-.048.481a1.3 1.3 0 0 1-.39.064c-.3 0-.55-.123-.672-.352-.18-.284-.444-.34-.729-.34q-.143.002-.291.012-.147.011-.292.013-.132 0-.257-.021z",
    style: {
      fill: "#b39f49",
      fillRule: "nonzero"
    },
    transform: "translate(281.173 177.978)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.081Q-.088-.536-.205 0q.288-.116.568-.253A13 13 0 0 1 0-1.081",
    style: {
      fill: "#b39f49",
      fillRule: "nonzero"
    },
    transform: "translate(255.219 148.81)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.174A23.5 23.5 0 0 0 4.438 0c.242-.096.419-.287.483-.648q.073.006.141.005c1.051 0 1.091-.933 1.999-1.4.034-.154.116-.296.213-.434A10.22 10.22 0 0 1 0-6.174",
    style: {
      fill: "#828344",
      fillRule: "nonzero"
    },
    transform: "translate(242.279 195.641)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-11.936a8.3 8.3 0 0 1-4.565.465l-.143.141a23.46 23.46 0 0 0-6.033 10.315Q-9.671-.58-8.652 0A18.55 18.55 0 0 0 0-11.936",
    style: {
      fill: "#9bb670",
      fillRule: "nonzero"
    },
    transform: "translate(254.936 165.299)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.219-1.964q.512.5.992 1.03c-.365.241-.699.53-.992.861a18 18 0 0 1-1.298.035 18 18 0 0 1 1.298-1.926",
    style: {
      fill: "#88ae58",
      fillRule: "nonzero"
    },
    transform: "matrix(-1.19529 .69263 .69263 1.19529 242.914 165.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.422A23.6 23.6 0 0 0-4.204-.13 8.33 8.33 0 0 0 .361-.595q.118-.536.205-1.081A14 14 0 0 1 0-3.422",
    style: {
      fill: "#8b834a",
      fillRule: "nonzero"
    },
    transform: "translate(254.437 149.632)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-18.776a10.25 10.25 0 0 0-6.001 1.932 18 18 0 0 1 2.325 1.959 17.56 17.56 0 0 1 5.158 12.46c0 .81-.055 1.621-.166 2.425.8-.109 1.399-.478 1.916-1.108.54-.627 1.336-.977 1.835-1.572.413-.601 1.102-1.034 1.799-1.334 1.246-.758 2.104-1.834 3.244-2.668q.16-.902.161-1.814a10.23 10.23 0 0 0-3.004-7.27A10.24 10.24 0 0 0 0-18.776",
    style: {
      fill: "#789c6b",
      fillRule: "nonzero"
    },
    transform: "translate(253.221 189.806)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-17.9q-.444.32-.859.693l.255.238a4.99 4.99 0 0 1 .776 6.057A30.8 30.8 0 0 1 5.644-.956c.165.308.293.629.402.956.397-.324.828-.645 1.092-1.023l.18-.033a18 18 0 0 0 .166-2.425 17.57 17.57 0 0 0-5.158-12.46A18 18 0 0 0 0-17.9",
    style: {
      fill: "#6a9557",
      fillRule: "nonzero"
    },
    transform: "translate(244.931 191.265)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.035C.113-.692.207-.346.307 0l.095-.079A6 6 0 0 0 0-1.035",
    style: {
      fill: "#667445",
      fillRule: "nonzero"
    },
    transform: "translate(252.728 191.375)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-9.957a5 5 0 0 1-4 2.452 23.5 23.5 0 0 0 1.602 4.811 6.1 6.1 0 0 1 2.491-.53c1.561 0 3.121.595 4.312 1.786.436.436.792.921 1.067 1.438A30.7 30.7 0 0 0 0-9.957",
    style: {
      fill: "#588455",
      fillRule: "nonzero"
    },
    transform: "translate(245.168 189.946)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.871c-.85 0-1.7.177-2.49.53q.147.324.306.643.307.37.655.719A10.23 10.23 0 0 0 5.09 0c.154-.216.363-.417.597-.612-.1-.346-.194-.692-.307-1.035a6 6 0 0 0-1.068-1.437A6.08 6.08 0 0 0 0-4.871",
    style: {
      fill: "#586844",
      fillRule: "nonzero"
    },
    transform: "translate(245.296 192.22)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-12.773-.058.018a8.3 8.3 0 0 1-2.046 3.356A8.3 8.3 0 0 1-4.32-7.811a13.7 13.7 0 0 0 2.683 3.782 13.7 13.7 0 0 0 10.47 4.01q.227-.255.473-.5a12.3 12.3 0 0 1 1.968-1.595c-.453-.036-.937.043-1.361-.161.122-1.105-.192-2.191.541-3.229.449 1.004.341 2.458 1.673 2.458l.089-.002.292-3.091-.858.587c-.571-1.248-.755-2.539-.689-3.847A16.08 16.08 0 0 1 0-12.773",
    style: {
      fill: "#b6d555",
      fillRule: "nonzero"
    },
    transform: "translate(261.689 159.252)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.487c-2.383 0-4.765.359-7.059 1.078A16.08 16.08 0 0 0 3.901-.035c.065-1.311.382-2.64.822-3.967A24 24 0 0 0 0-4.487",
    style: {
      fill: "#a9b24b",
      fillRule: "nonzero"
    },
    transform: "translate(271.441 146.316)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.094A12.2 12.2 0 0 0-2.441 0a13.7 13.7 0 0 0 5.27-1.376c-.269-.02-.56-.108-.809-.108l-.044.001a.7.7 0 0 1-.2.032c-.422 0-.767-.41-1.201-.497A1.5 1.5 0 0 0 0-2.094",
    style: {
      fill: "#9d9742",
      fillRule: "nonzero"
    },
    transform: "translate(277.264 159.224)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-4.943a23.4 23.4 0 0 0-4.411 1.911q-.041 1.118-.214 2.204.168.42.363.828a8.3 8.3 0 0 0 2.217-1.588A8.3 8.3 0 0 0 0-4.943",
    style: {
      fill: "#9d9742",
      fillRule: "nonzero"
    },
    transform: "translate(261.608 148.46)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.205q-.393.221-.781.459.224.888.567 1.746.172-1.087.214-2.205",
    style: {
      fill: "#7b8045",
      fillRule: "nonzero"
    },
    transform: "translate(255.515 147.317)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-14.007a15.5 15.5 0 0 1-9.151 2.981q-1.123 0-2.237-.161A12.1 12.1 0 0 0-7.87-3.554 12.1 12.1 0 0 0 .713 0a12.1 12.1 0 0 0 8.583-3.554 12.2 12.2 0 0 0 2.059-2.739 27 27 0 0 1-.07-.625 13.9 13.9 0 0 1-8.983-4.058A14 14 0 0 1 0-14.007",
    style: {
      fill: "#d1e070",
      fillRule: "nonzero"
    },
    transform: "translate(124.663 137.084)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-12.331a12.1 12.1 0 0 0-3.944 2.637A12.1 12.1 0 0 0-7.462-.161q1.113.16 2.236.161c3.217 0 6.434-.994 9.151-2.981a13.93 13.93 0 0 1-1.77-7.423 5.1 5.1 0 0 1-1.424-1.008A5.2 5.2 0 0 1 0-12.331",
    style: {
      fill: "#c0bc5a",
      fillRule: "nonzero"
    },
    transform: "translate(119.24 121.852)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.14-3.16c.472.735.866 1.525 1.171 2.355q-.568.106-1.171.085a5.1 5.1 0 0 1-1.705-.365A14 14 0 0 0-1.14-3.16",
    style: {
      fill: "#758658",
      fillRule: "nonzero"
    },
    transform: "scale(-1.38147 1.38147)rotate(-47.342 44.319 136.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-16.158a15.45 15.45 0 0 1-4.156 7.502A15.6 15.6 0 0 1-5.982-7.09 14 14 0 0 0-3.68-4.059C-1.18-1.559 2.032-.206 5.303 0a35.5 35.5 0 0 1 .457-10.295 12.1 12.1 0 0 0-2.446-3.508A12.1 12.1 0 0 0 0-16.158",
    style: {
      fill: "#8aa970",
      fillRule: "nonzero"
    },
    transform: "translate(132.927 127.528)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-9.524a5.2 5.2 0 0 1-.834 1.093 5.13 5.13 0 0 1-3.634 1.505 5.1 5.1 0 0 1-2.21-.498A13.94 13.94 0 0 0-4.907 0q.959-.702 1.826-1.566a15.46 15.46 0 0 0 4.155-7.503Q.546-9.323 0-9.524",
    style: {
      fill: "#838f59",
      fillRule: "nonzero"
    },
    transform: "translate(131.442 117.734)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.343c-.708 0-1.415.061-2.113.184-.21.875-.333 1.767-.37 2.66A5.1 5.1 0 0 0-.273 0 5.12 5.12 0 0 0 3.36-1.506c.334-.333.612-.701.835-1.093A12.2 12.2 0 0 0 0-3.343",
    style: {
      fill: "#587153",
      fillRule: "nonzero"
    },
    transform: "translate(125.647 108.167)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.625Q.031-.313.07 0q.163-.3.31-.607Q.19-.613 0-.625",
    style: {
      fill: "#c1da60",
      fillRule: "nonzero"
    },
    transform: "translate(140.253 128.391)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-10.313A35.3 35.3 0 0 0-.457-.018q.19.011.38.018a12.14 12.14 0 0 0 1.185-5.232A12.1 12.1 0 0 0 0-10.313",
    style: {
      fill: "#80a561",
      fillRule: "nonzero"
    },
    transform: "translate(140.884 127.553)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.177q-1.078.426-2.226.719Q-1.228-.772-.275 0-.188-1.093 0-2.177",
    style: {
      fill: "#b99849",
      fillRule: "nonzero"
    },
    transform: "translate(239.383 170.066)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.353q-.777.198-1.583.33l-.307.048a4.97 4.97 0 0 0-.991 2.996 4.97 4.97 0 0 0 1.462 3.518A4.97 4.97 0 0 0 2.025 0a10.4 10.4 0 0 1 .009-2.294 24 24 0 0 1-.083-4.6A31 31 0 0 0 0-8.353",
    style: {
      fill: "#95844a",
      fillRule: "nonzero"
    },
    transform: "translate(236.308 179.591)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.627A4.97 4.97 0 0 0-3.025-.606q.461.293.915.606A18 18 0 0 0 .116-.719q.08-.45.175-.9A6 6 0 0 0 0-1.627",
    style: {
      fill: "#90804c",
      fillRule: "nonzero"
    },
    transform: "translate(239.223 168.051)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.984a5 5 0 0 0-.504.442A5 5 0 0 0-.974 0l.307-.048a19 19 0 0 0 1.582-.33A30 30 0 0 0 0-.984",
    style: {
      fill: "#78724b",
      fillRule: "nonzero"
    },
    transform: "translate(235.043 168.573)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.295A10.4 10.4 0 0 0-.01-.001L.075 0q.153 0 .304-.01A24 24 0 0 1 0-2.295",
    style: {
      fill: "#63684a",
      fillRule: "nonzero"
    },
    transform: "translate(239.118 179.592)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-3.844a18 18 0 0 1-1.464.652 24 24 0 0 0-.275 2.178Q-1.134-.524-.551 0a10.3 10.3 0 0 1 2.243-2.877A5 5 0 0 0 0-3.844",
    style: {
      fill: "#9a8f40",
      fillRule: "nonzero"
    },
    transform: "translate(241.406 171.468)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.072-4.61q.091.932.108 1.869.026 1.368-.108 2.732A10.3 10.3 0 0 0-.097-3.574q.574-.534 1.169-1.036",
    style: {
      fill: "#807e43",
      fillRule: "nonzero"
    },
    transform: "matrix(-1.38124 .02492 .02492 1.38124 240.6 176.407)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.9q-.096.45-.175.9.75-.296 1.464-.652A5 5 0 0 0 0-.9",
    style: {
      fill: "#7b7b43",
      fillRule: "nonzero"
    },
    transform: "translate(239.625 167.058)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-6.295a10.3 10.3 0 0 0-2.243 2.877q.626.562 1.226 1.162A31 31 0 0 1 1.031 0a5 5 0 0 0 .686-2.525A4.97 4.97 0 0 0 .255-6.056z",
    style: {
      fill: "#646e43",
      fillRule: "nonzero"
    },
    transform: "translate(243.744 176.19)scale(1.38147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-5.871a10.2 10.2 0 0 0-1.105 3.586Q-.972-1.135-.726 0a4.97 4.97 0 0 0 3.224-1.452 5 5 0 0 0 .775-1.001A31.6 31.6 0 0 0 0-5.871",
    style: {
      fill: "#576543",
      fillRule: "nonzero"
    },
    transform: "translate(240.646 179.579)scale(1.38147)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnbs);
export default __webpack_public_path__ + "static/media/ENBS.132bda10b7cbdb2885dbd5e0efa39177.svg";
export { ForwardRef as ReactComponent };